export const cpfPattern = ['999.999.999-99'];
export const yearPattern = ['9999'];
export const cnpjPattern = ['99.999.999/9999-99'];
export const phonePattern = ['(99)9.9999-9999'];
